export const GETALL_SUPPLIER_REQUEST = "GETALL_SUPPLIER_REQUEST";
export const GETALL_SUPPLIER_SUCCESS = "GETALL_SUPPLIER_SUCCESS";
export const GETALL_SUPPLIER_FAIL = "GETALL_SUPPLIER_FAIL";

export const GETBYID_SUPPLIER_REQUEST = "GETBYID_SUPPLIER_REQUEST";
export const GETBYID_SUPPLIER_SUCCESS = "GETBYID_SUPPLIER_SUCCESS";
export const GETBYID_SUPPLIER_FAIL = "GETBYID_SUPPLIER_FAIL";

export const ADD_SUPPLIER_REQUEST = 'ADD_SUPPLIER_REQUEST';   
export const ADD_SUPPLIER_SUCCESS = 'ADD_SUPPLIER_SUCCESS';
export const ADD_SUPPLIER_FAIL = 'ADD_SUPPLIER_FAIL';

export const UPDATE_SUPPLIER_REQUEST = 'UPDATE_SUPPLIER_REQUEST';
export const UPDATE_SUPPLIER_SUCCESS = 'UPDATE_SUPPLIER_SUCCESS';
export const UPDATE_SUPPLIER_FAIL = 'UPDATE_SUPPLIER_FAIL';

export const DELETE_SUPPLIER_REQUEST = 'DELETE_SUPPLIER_REQUEST';
export const DELETE_SUPPLIER_SUCCESS = 'DELETE_SUPPLIER_SUCCESS';
export const DELETE_SUPPLIER_FAIL = 'DELETE_SUPPLIER_FAIL'; 
